export default {
  title: "General terms of participation",
  orderParticipate: "Participation procedure",
  orderExhib: "Participation procedure",
  applicationTitle: "Participation application",
  applicationDescription:
    "In order to register for participation in the exhibition, the exhibitor shall forward to EXPOCENTRE JSC an application. The reception of application starts one year in advance and finishes, as usual, three-four months before the exhibition.",
  commercialTitle: "Commercial offer approval",
  commercialDescription:
    "The cost of renting space is set up taking into account the status of each exhibition, configuration and location of booths in the pavilions. The commercial offer is able to receive after the filling the application form.",
  commertialDescr: {
    include1: "The package of the exhibition participant includes:",
    include2:
      "loading/unloading of exhibits, mounting/dismantling of equipment;",
    include3:
      "consumption of electric energy within 100 watts of installed capacity per 1 sq m of the rented space;",
    include4:
      "cleaning of the shared exhibition area and aisles in pavilions and open-air lots (excluding the booth area);",
    include5:
      "work and Service Passes (to technicians, engineers, booth builders) and one-entry car passes for the mounting/dismantling period (only for loading/unloading procedures);",
    include6: "exhibitor passes;",
    include7:
      "free of charge at the rate:one pass for every 3 sq m of the rented space if the booth area is up to 90 sq m (inclusive); 30 passes and one additional pass for every 6 sq m of the rented space if the exhibitor booth is more than 90 sq m.",
    include8: "invitations for guests of participants (free of charge);",
    include9:
      "Invitations are given in Exhibition Management (in case of 100% booth payment).",
    include10:
      "publication of information about the exhibitor in the Exhibition Official Catalogue as stipulated in art. 12.4. of the present General Terms of Participation, one copy of the Exhibition Official Catalogue (in the event of publication);",
    include11: "MatchMaking (business meetings) System services;",
    include12:
      "E-Invite System (service of e-mailing the e-tickets to the exhibition to your partners and clients)",
    include13:
      "Marketing opportunities (publication of news and novelties on the exhibition website, press-center services and etc.);",
    include14:
      "Participation in the seminar “Efficient trade show participation”",
    include15:
      "For participants of trade shows organized by EXPOCENTRE JSC is included in the participation cost.",
    include16:
      "For companies, which are not exhibitors of trade shows organized by EXPOCENTRE JSC the participation in the seminar is paid on the basis of an invoice issued by EXPOCENTRE JSC.",
    include17:
      "Depending on the number of participants, special conditions are provided."
  },
  signContract: {
    title: "Contract signing",
    info1:
      "After all the conditions of participation have been agreed between EXPOCENTRE JSC and the Exhibitor, a contract for participation in the exhibition is concluded, as a rule, not later than 90 days before the Mounting start. An integral part of the contract are the General terns of participation with all annexes, as well as amendments and additions. The organization of group booths is allowed at the exhibitions.",
    info2: "The organization of group booths is allowed at the exhibitions.",
    info3:
      "For the prompt solution of questions of preparation and exhibition holding, it is allowed the conclusion of the contract and the transfer of other documents by exchange of Fax messages and electronic mail with mandatory back up dispatch of originals of the specified documents between EXPOCENTRE JSC and the Exhibitor."
  },
  payment: {
    title: "Payment",
    info1:
      "The exhibitor pays an obligatory registration fee, amount of which is set by EXPOCENTRE JSC for each exhibition. The fee covers expenses on the organization and publicity campaign of the exhibition. If the exhibitor withdraws from the exhibition, the registration fee shall not be reimbursed.",
    info2:
      "Companies that have not fully paid off the debt for the rented area, equipment or additional services ordered are not allowed to the exhibition Mounting.",
    info3: ""
  },
  closingDocs: {
    title: "Closing documents",
    info1:
      "The closing documents (invoice, statement of acceptance of completed services and exhibition areas) can be received on the last day of the exhibition.",
    info2:
      "The authorized representative of the company should sign the statement of acceptance of completed services and exhibition areas during Mounting period. The authorized representative must have the",
    info3:
      "and 2 originals of pavilion stand schemes (if for any reason they were not provided earlier) with him or her.",
    info4:
      'More details in the "Exhibitor\'s Manual" on the website of the exhibition.'
  },
  mainDocuments: {
    title: "Basic documents and forms",
    doc1: "General Terms of Participation",
    doc2: "General Terms for Holding Events at Expocentre Fairgrounds"
  },
  standBuilding: {
    title: "Booth construction",
    doc:
      "Rules for Contractors of Exhibition Stands and Expositions at Expocentre Fairgrounds"
  },
  leavingOrder: {
    title: "Procedure for Delivery/Removal of Equipment and Exhibits",
    doc1: "Procedure for Delivery/Removal of Equipment and Exhibits",
    doc2: "Rules for the Use of Vehicles at Expocentre Fairgrounds"
  },
  attorney: {
    title: "Power of Attorney",
    doc1: "Power of Attorney",
    doc2: ""
  },
  onlineService: {
    title: "Online-services for participants",
    doc1: "Business MatchMaking System Regulations",
    doc2: "Regulations on E-Invite System of Invitation Mail Out"
  },
  attentionNote: {
    title: "Attention",
    info1:
      "Please note that this website is intended to provide information only and should not be interpreted as a public offer as described by the Article 437 of the Civil Code of the Russian Federation. Participation in an exhibition shall be documented by a contract. Each contract is negotiated on a case-by-case basis. This procedure is regulated by the General Terms of Participation in Exhibitions Held at Expocentre Fairgrounds.",
    info2: ""
  },
  note: "Note"
};
